export default __webpack_public_path__ + "static/media/company_banner_bottom_m.ea52ae5e.png";